import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48a225ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-theme" }
const _hoisted_2 = { class: "theme-head" }
const _hoisted_3 = { class: "theme-head__title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "theme-head__title-name"
}
const _hoisted_6 = { class: "theme-head__operate" }
const _hoisted_7 = { class: "common-select-layout" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主题色", -1))
const _hoisted_9 = { class: "common-select-layout__extra" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "common-select-layout" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自定义主题色", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-theme-divider" }, null, -1))
const _hoisted_14 = { class: "common-select-layout" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "背景图", -1))
const _hoisted_16 = {
  class: "common-select-layout__extra",
  ref: "divRef"
}
const _hoisted_17 = { class: "vector-popover-wrap" }
const _hoisted_18 = { class: "upload-image__btn" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传图片", -1))
const _hoisted_20 = { class: "image-list" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "common-select-layout"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "背景图应用到手机界面", -1))
const _hoisted_25 = { class: "common-select-layout" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "背景蒙层模糊", -1))
const _hoisted_27 = {
  key: 0,
  class: "custom-theme-divider"
}
const _hoisted_28 = { class: "common-select-layout" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "导航标签布局", -1))

import { nextTick, ref, watch } from 'vue'
import {
  NSpace,
  NPopover,
  NUpload,
  NCheckbox,
  NSwitch,
  NScrollbar
} from 'naive-ui'
import Icon from '@teams/common/components/icon'
import CustomColorPicker from './customColorPicker.vue'
import PopoverSelect from './popoverSelect.vue'
import bg1 from '@/assets/defaultBackgroundImage/preview_6.jpg'
import bg2 from '@/assets/defaultBackgroundImage/preview_7.jpg'
import bg3 from '@/assets/defaultBackgroundImage/preview_8.jpg'
import bg4 from '@/assets/defaultBackgroundImage/preview_9.jpg'
import { ICustomThemeProps, useCustomePanal } from '../useCustomePanal'
import { FileInfo } from 'naive-ui/es/upload/src/interface'
import { ICaseItem } from '../pcCustom.vue'
import ColorPicker from '@/components/colorpicker/index.vue'
import { themeColorPanelList } from '@teams/common/config/colorTheme/themes'
import { useH5PreviewPreference } from '@/views/home/preview'
import usePreference from '@teams/common/hooks/usePreference'
import { groupHeadBackgroundImg } from '@teams/common/store/preference/constant'

interface Emits {
  (e: 'onThemePanelChange', value: string): void
  (e: 'back'): void
  (e: 'onRefresh'): void
  (e: 'onSave'): void
  (e: 'onUpdateSwitch', value: boolean): void
  (e: 'onVectorImgSelect', url: string): void
  (e: 'onShowSelector'): void
  (e: 'onChangeUpload', options: { file: FileInfo }): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'newTheme',
  props: {
    customThemeProps: null,
    isPcCustom: { type: Boolean },
    currentItem: null,
    showNavSwitch: { type: Boolean }
  },
  emits: ["onThemePanelChange", "back", "onRefresh", "onSave", "onUpdateSwitch", "onVectorImgSelect", "onShowSelector", "onChangeUpload"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onThemePanelChange', value: string): void
  (e: 'back'): void
  (e: 'onRefresh'): void
  (e: 'onSave'): void
  (e: 'onUpdateSwitch', value: boolean): void
  (e: 'onVectorImgSelect', url: string): void
  (e: 'onShowSelector'): void
  (e: 'onChangeUpload', options: { file: FileInfo }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  customThemeProps: ICustomThemeProps
  isPcCustom: boolean
  currentItem: ICaseItem
  showNavSwitch: boolean
}

const { handleThemeChange } = useCustomePanal('pc')
const preference = usePreference()
const h5PreviewPreference = useH5PreviewPreference()


const backToTheme = () => {
  emit('back')
}



const defaultThemeColor = ref<string[]>(Object.values(themeColorPanelList))
// 当前选中的主题色
const isCurrentVectorImgId = ref<number>(0)
const checked = ref(props.customThemeProps.isUsePcBackgroundToH5)

// 全局颜色项
const globalColorOptions = ref(props.customThemeProps.globalColorOptions)
// 页头颜色项
const pageHeadColorOptions = ref(props.customThemeProps.pageHeadColorOptions)
// 导航栏颜色项
const navBarColorOptions = ref(props.customThemeProps.navBarColorOptions)

// 背景图弹出框
const showSelector = ref(false)

// 矢量背景图
const vectorImage = ref([
  {
    imgUrl: bg1,
    title: '矢量'
  },
  {
    imgUrl: bg2,
    title: '淡雅'
  },
  {
    imgUrl: bg3,
    title: '云雾'
  },
  {
    imgUrl: bg4,
    title: '建筑'
  }
])

watch([() => props.customThemeProps], () => {
  pageHeadColorOptions.value = props.customThemeProps.pageHeadColorOptions
  pageHeadColorOptions.value = props.customThemeProps.pageHeadColorOptions
  navBarColorOptions.value = props.customThemeProps.navBarColorOptions
})

// 全局 主题色选择
const handleColorSelector = (color: string) => {
  emit('onThemePanelChange', color)
}
// 气泡弹窗开闭回调
const handleShowSelector = () => {
  showSelector.value = !showSelector.value
}
// 关闭气泡弹窗
const handleCloseSelector = () => {
  showSelector.value = false
}

const updateShowPopover = async () => {
  handleShowSelector()
  await nextTick()
  if (!showSelector.value) {
    handleCloseSelector()
  }
}

const handleChangeUpload = (options: { file: FileInfo }) => {
  handleCloseSelector()
  emit('onChangeUpload', options)
}
// 矢量背景图选择
const handleVectorImgSelect = (url: string, index: number) => {
  isCurrentVectorImgId.value = index
  handleCloseSelector()
  emit('onVectorImgSelect', url)
}

// 还原主题
const refreshTheme = () => {
  emit('onRefresh')
}

// 保存主题`
const saveCustomTheme = () => {
  emit('onSave')
}

const handleUseToH5 = (val: boolean) => {
  checked.value = val
  handleThemeChange('use-pc-background-to-h5', val.toString())
  if (val) {
    const link = preference.current.theme.styles[
      groupHeadBackgroundImg
    ] as string
    h5PreviewPreference.changeCurrentPreference({
      themes: [{ key: 'group-head-background-img', value: link }]
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Icon), {
          name: "backPrePage",
          fill: "transparent",
          onClick: backToTheme
        }),
        (__props.currentItem?.official)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "自定义主题"))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.currentItem?.name), 1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(NSpace), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Icon), {
              name: "themeRefresh",
              fill: "transparent",
              onClick: refreshTheme
            }),
            _createVNode(_unref(Icon), {
              name: "themeSave",
              fill: "transparent",
              onClick: saveCustomTheme
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_unref(NScrollbar), { style: {"{\n          max-height":"100%"} }, {
      default: _withCtx(() => [
        _createVNode(CustomColorPicker, {
          title: "全局",
          "color-options": globalColorOptions.value
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultThemeColor.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "default-theme",
                    key: item,
                    onClick: ($event: any) => (handleColorSelector(item)),
                    style: _normalizeStyle({
                  borderColor:
                    props.customThemeProps.currentThemeColor === item
                      ? item
                      : ''
                })
                  }, [
                    _createElementVNode("div", {
                      class: "default-theme__color",
                      style: _normalizeStyle({ background: item })
                    }, null, 4)
                  ], 12, _hoisted_10))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(ColorPicker, {
                color: props.customThemeProps.currentThemeColor,
                "onUpdate:color": handleColorSelector
              }, null, 8, ["color"])
            ])
          ]),
          _: 1
        }, 8, ["color-options"]),
        _hoisted_13,
        _createVNode(CustomColorPicker, {
          title: "页头",
          "color-options": pageHeadColorOptions.value
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_unref(NPopover), {
                placement: "bottom-end",
                trigger: "click",
                "show-arrow": false,
                class: "vector-background-popover",
                show: showSelector.value,
                onUpdateShow: updateShowPopover
              }, {
                trigger: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                      'vector-background',
                      { 'vector-background-active': showSelector.value }
                    ])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                        'vector-background__text',
                        { 'vector-background__text-active': showSelector.value }
                      ])
                      }, "官方-" + _toDisplayString(vectorImage.value[isCurrentVectorImgId.value].title), 3),
                      _createElementVNode("span", {
                        class: _normalizeClass([
                        'vector-background__icon',
                        { 'vector-background__icon-active': showSelector.value }
                      ])
                      }, null, 2)
                    ], 2)
                  ], 512)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_unref(NUpload), {
                      class: "upload-image",
                      accept: ".png,.jpg,.jpeg,.svg,.bmp",
                      "show-file-list": false,
                      "default-upload": false,
                      onChange: handleChangeUpload
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_unref(Icon), {
                            name: "uploadThemeImage",
                            fill: "transparent"
                          }),
                          _hoisted_19
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vectorImage.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["image-list__content", 
                      isCurrentVectorImgId.value === index
                        ? 'image-list__content-active'
                        : ''
                    ]),
                          key: index,
                          onClick: ($event: any) => (handleVectorImgSelect(item.imgUrl, index))
                        }, [
                          _createElementVNode("img", {
                            src: item.imgUrl,
                            alt: ""
                          }, null, 8, _hoisted_22),
                          _createElementVNode("span", null, _toDisplayString(item.title), 1)
                        ], 10, _hoisted_21))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            (__props.isPcCustom)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(_unref(NCheckbox), {
                    checked: checked.value,
                    onUpdateChecked: handleUseToH5
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_unref(NSwitch), {
                "default-value": __props.customThemeProps.backgroundCoverMask.visible,
                "onUpdate:value": __props.customThemeProps.backgroundCoverMask.onChange
              }, null, 8, ["default-value", "onUpdate:value"])
            ])
          ]),
          _: 1
        }, 8, ["color-options"]),
        (__props.showNavSwitch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27))
          : _createCommentVNode("", true),
        (__props.showNavSwitch)
          ? (_openBlock(), _createBlock(CustomColorPicker, {
              key: 1,
              title: "导航栏",
              "color-options": navBarColorOptions.value
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(PopoverSelect, {
                    "custom-list": props.customThemeProps.navBarItemStyle.options,
                    "init-key": props.customThemeProps.navBarItemStyle.key
                  }, null, 8, ["custom-list", "init-key"])
                ])
              ]),
              _: 1
            }, 8, ["color-options"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})